import { Box, Typography } from '@mui/material';
import { defineMessages, useIntl } from 'react-intl';
import { QUALITY_TIMELINE } from '../consts';

const messages = defineMessages({
  label: {
    id: 'logger.reports.streamQuality.stationStatusFilter.disabledAnalysisIntervalsLegend',
    defaultMessage: '= Intervalo sin verificación de calidad',
  },
});

/**
 * Compact legend for the timeline hatch: intervals where audio quality analysis was disabled.
 */
export function DisabledIntervalsLegend() {
  const { $t } = useIntl();
  const { chartColors } = QUALITY_TIMELINE;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        ml: 2,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          width: 28,
          height: 14,
          borderRadius: 0.5,
          border: 1,
          borderColor: 'divider',
          background: `repeating-linear-gradient(
            45deg,
            ${chartColors.minimapNeutral},
            ${chartColors.minimapNeutral} 2px,
            ${chartColors.grid} 2px,
            ${chartColors.grid} 4px
          )`,
        }}
      />
      <Typography component="span" variant="body2" color="text.secondary">
        {$t(messages.label)}
      </Typography>
    </Box>
  );
}
